import { FC, MouseEvent } from 'react'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useWebLayout } from 'featureSliced/shared/hooks/useWebLayout'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { roundValueTo } from 'featureSliced/shared/utils/roundValueTo'
import { ProductGrided } from '../ProductGrided/ProductGrided'
import { ProductListed } from '../ProductListed/ProductListed'
import { ProductsGrid, ProductsList } from '../styled'

type ProductsProps = {
  products: IProduct[]
  templateId: number
  onProductClick: (product: IProduct, e: MouseEvent<HTMLElement>) => void
}

export const MenuProducts: FC<ProductsProps> = ({
  products,
  templateId,
  onProductClick,
}) => {
  // Store
  const selectedProducts = useMySelector((state) => state.bucket.products)
  const { productViewType } = useMySelector(
    (state) => state.app.interfaceStyles
  )
  const { isWeb } = useWebLayout()

  // QRM-641 (team decision): the web layout always shows tiles. The venue's
  // `productViewType` still rules the phone layout — a list row stretched across
  // the desktop content column puts the price a screen away from the name.
  const isListView = productViewType === 'list' && !isWeb

  const ContainerComponent = isListView ? ProductsList : ProductsGrid
  const ProductsComponent = isListView ? ProductListed : ProductGrided

  // Functions
  const getAmount = (product: IProduct) => {
    return selectedProducts?.reduce((acc, curr) => {
      if (
        curr.productId === product.id &&
        curr.productTemplateId === templateId
      ) {
        return roundValueTo(acc + curr.count)
      } else {
        return acc
      }
    }, 0)
  }

  return (
    <ContainerComponent>
      {products?.slice()?.map((product, i) => {
        return (
          <ProductsComponent
            // withLazy
            key={`${product?.id}_${i}`}
            product={product}
            templateId={templateId}
            amount={getAmount(product)}
            onProductClick={onProductClick}
            showPricePerItem={true}
          />
        )
      })}
    </ContainerComponent>
  )
}
